import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  type ChartOptions,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { watchProgress } from "../../types/watchProgress";
import { UsersStats } from "../../types/UsersStats";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

type Props = {
  data: watchProgress | UsersStats;
};

export default function BaseBarChart({ data }: Props) {
  if (!data) return null;

  const chartSource = data.data;

  // Build chart data from API
  const chartData = {
    labels: chartSource.labels,
    datasets: chartSource.series.map((serie) => ({
      label: serie.title,
      data: serie.data,
      backgroundColor: "rgba(247, 189, 55, 0.7)",
      borderColor: "rgba(247, 189, 55, 1)",
      borderWidth: 1,
      borderRadius: 4, // smooth bar edges
      maxBarThickness: 40,
    })),
  };

  // Build options dynamically from API
  const options: ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: chartSource.title,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: chartSource.xAxisLabel,
          font: {
            weight: "bold",
          },
        },
        grid: {
          display: false,
        },
      },
      y: {
        title: {
          display: true,
          text: chartSource.yAxisLabel,
          font: {
            weight: "bold",
          },
        },
        beginAtZero: true,
        grid: {
          color: "rgba(0,0,0,0.1)",
        },
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "400px", position: "relative" }}>
      <Bar options={options} data={chartData} />
    </div>
  );
}
